import Vue from 'vue';
import { Button, Popover } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'; // or 'ant-design-vue/dist/antd.less'
const components = [Button, Popover]
components.forEach((component) => {
  Vue.use(component);
})